import { __assign } from "tslib";
/**
 * Provides a hook that returns the corresponding asset URL of the SPA. It handles cases where your SPA is injected into the shell.
 *
 * This hooks is very useful for serving and using static assets within your SPA.
 *
 * Usage:
 *
 * const ASSETS_URL = useSPAAssetsUrl('@didomi-spa/compliance-report');
 *
 * [...]
 *
 * <img src={`${ASSETS_URL}/assets/images/mySvg.svg`} alt="" />
 */
export var useSPAAssetsUrl = function (applicationName, _a) {
    var _b, _c, _d;
    var _e = _a === void 0 ? { isStandalone: false } : _a, isStandalone = _e.isStandalone;
    var defaultImports = (_b = window === null || window === void 0 ? void 0 : window.DIDOMI_SPA_IMPORTS_MAP) !== null && _b !== void 0 ? _b : {};
    //@ts-ignore
    var customImports = ((_d = (_c = window === null || window === void 0 ? void 0 : window.importMapOverrides) === null || _c === void 0 ? void 0 : _c.getOverrideMap()) === null || _d === void 0 ? void 0 : _d.imports) || {};
    var OVERRIDE_MAPS = __assign(__assign({}, defaultImports), customImports);
    var spaLocation = OVERRIDE_MAPS[applicationName];
    return isStandalone || !spaLocation ? window.location.origin : new URL(OVERRIDE_MAPS[applicationName]).origin;
};
